import { render, staticRenderFns } from "./DocumentMerge.vue?vue&type=template&id=19c659e1"
import script from "./DocumentMerge.vue?vue&type=script&lang=js"
export * from "./DocumentMerge.vue?vue&type=script&lang=js"
import style0 from "./DocumentMerge.vue?vue&type=style&index=0&id=19c659e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports